import { render, staticRenderFns } from "./PaymentMethodB2C.vue?vue&type=template&id=10221d6f&scoped=true&"
import script from "./PaymentMethodB2C.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodB2C.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodB2C.vue?vue&type=style&index=0&id=10221d6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10221d6f",
  null
  
)

export default component.exports